class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'), 10) || 5000;
        this.expiresDate = Math.max(1, parseInt(this.popup.getAttribute('data-expire'), 10) || 1);
        this.showTimeoutId = null;
        this.imageTimeoutId = null;

        if (!this.isDismissed()) {
            this.showTimeoutId = setTimeout(() => {
                if (this.isDismissed()) return;
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            this.imageTimeoutId = setTimeout(() => {
                if (this.isDismissed()) return;
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700);
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup')?.addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        this.dismissLabel = this.querySelector('label[for="dismiss"]') || this.querySelector('label[for="guardian-dismiss"]');
        if (this.dismissLabel) {
        this.dismissLabel.addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
        }

        if(this.classList.contains('style-2')){
            this.copyButton = this.querySelector('.button-code--copy');
            if(this.copyButton){
                this.copyButton.addEventListener('click', () => {
                    this.inputField = this.querySelector('.code__input .field__input');
                    this.tooltip = this.copyButton.querySelector('.tooltip');
                    navigator.clipboard.writeText(this.inputField.value).then(() => {
                    this.tooltip.textContent =  this.tooltip.dataset.success_message;
                    });
                });
            }

            $('.halo-newsletter-popup.style-2 .products-grid:has(.product:nth-child(3))')?.slick({
                infinite: true,
                arrows: true,
                dots: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                slidesToShow: 2,
                slidesToScroll: 2,
                rtl: window.rtl_slick
            });
        }
    }

    get storageKey() {
        return 'newsletter-popup-closed';
    }

    isDismissed() {
        if (this.getCookie('newsletter-popup') === 'closed') return true;
        try {
            const raw = localStorage.getItem(this.storageKey);
            if (!raw) return false;
            const data = JSON.parse(raw);
            if (!data || !data.until) return false;
            if (Date.now() < data.until) return true;
            localStorage.removeItem(this.storageKey);
            return false;
        } catch (e) {
            return false;
        }
    }

    persistDismissed(exdays) {
        const days = Math.max(1, parseInt(exdays, 10) || 1);
        this.setCookie('newsletter-popup', 'closed', days);
        try {
            localStorage.setItem(this.storageKey, JSON.stringify({
                until: Date.now() + days * 24 * 60 * 60 * 1000
            }));
        } catch (e) {
            // ignore quota / private mode
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }

    clearShowTimers() {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
            this.showTimeoutId = null;
        }
        if (this.imageTimeoutId) {
            clearTimeout(this.imageTimeoutId);
            this.imageTimeoutId = null;
        }
    }

    setClosePopup() {
        this.clearShowTimers();
        this.persistDismissed(this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)
    }

    onBodyClickEvent(event){
        if (!document.body.classList.contains('newsletter-show')) return;
        if ($(event.target).closest('[data-open-newsletter-popup]').length) return;
        if (this.contains(event.target)) return;

        // 守护神翻牌：全程禁止点遮罩关闭，只允许点叉 / Continue / No thanks
        if (this.classList.contains('style-guardian-card')) return;

        this.setClosePopup();
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);